export * from "./CampaignLargeWithAuthor";
